export default {
  tableHeadersAttributes: {
    id: 'bo_sellers-listing-search-product-card-attributes-table-header-attributes',
    defaultMessage: 'Attributes',
  },
  tableHeadersValues: {
    id: 'bo_sellers-listing-search-product-card-attributes-table-header-values',
    defaultMessage: ' ',
  },
  attributeNameBrand: {
    id: 'bo_sellers-listing-search-product-card-attributes-name-brand',
    defaultMessage: 'Brand',
  },
  attributeNameEan: {
    id: 'bo_sellers-listing-search-product-card-attributes-name-ean',
    defaultMessage: 'EAN',
  },
  attributeNameHeight: {
    id: 'bo_sellers-listing-search-product-card-attributes-name-height',
    defaultMessage: 'Height',
  },
  attributeNameWidth: {
    id: 'bo_sellers-listing-search-product-card-attributes-name-width',
    defaultMessage: 'Width',
  },
  attributeNameWeight: {
    id: 'bo_sellers-listing-search-product-card-attributes-name-weight',
    defaultMessage: 'Weight',
  },
  attributeNameDepth: {
    id: 'bo_sellers-listing-search-product-card-attributes-name-depth',
    defaultMessage: 'Depth',
  },
  categoryId: {
    id: 'bo_sellers-listing-search-product-card-attributes-category-id',
    defaultMessage: 'Category Id',
  },
  categoryName: {
    id: 'bo_sellers-listing-search-product-card-attributes-category-name',
    defaultMessage: 'Category Name',
  },
}
